import { render, staticRenderFns } from "./EstablishmentInternalInvoiceStatusBadge.vue?vue&type=template&id=19024d96"
import script from "./EstablishmentInternalInvoiceStatusBadge.vue?vue&type=script&lang=js"
export * from "./EstablishmentInternalInvoiceStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports